// extracted by mini-css-extract-plugin
export default {"competitor":"Competitor_competitor__njPgC","nameContainer":"Competitor_nameContainer__U0+eX","name":"Competitor_name__TMR9T","jockey":"Competitor_jockey__3+4yf"};